import React from 'react';
import { Img } from 'react-image';

function Image({
  src,
  alt = "Image Name",
  className = "",
  loader,
  unloader,
  ...props
}) {
  // Default loader component
  const defaultLoader = (
    <div className={`${className} bg-muted animate-pulse flex items-center justify-center`}>
      <div className="text-muted-foreground text-sm">Loading...</div>
    </div>
  );

  // Default unloader component (fallback image)
  const defaultUnloader = (
    <img
      src="/assets/images/no_image.png"
      alt={alt}
      className={className}
      {...props}
    />
  );

  return (
    <Img
      src={src}
      alt={alt}
      className={className}
      loader={loader || defaultLoader}
      unloader={unloader || defaultUnloader}
      {...props}
    />
  );
}

export default Image;
